import React from 'react';

const SaveSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M10.5 7.5V5h5v6.5h-7V5h1v2.5h1zm6 5V5h.6L20 8.6V20H5V5h2.5v7.5h9zM4 4v17h17V8.3L17.6 4H4z"
        />
    </svg>
);

SaveSvg.displayName = 'SaveSvg';
export default SaveSvg;
